import { render } from "./DemurrageStatistics.vue?vue&type=template&id=7d23929d&scoped=true"
import script from "./DemurrageStatistics.vue?vue&type=script&lang=js"
export * from "./DemurrageStatistics.vue?vue&type=script&lang=js"

import "./DemurrageStatistics.vue?vue&type=style&index=0&id=7d23929d&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/smartsim-ui-new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d23929d"]])

export default __exports__